import {writable} from 'svelte/store';

const {set, update, subscribe} = writable({
    visible: false,
    message: "",
});

let tm = null;

const error = {
    set, update, subscribe, show: msg => {
        clearTimeout(tm);
        update(state => {
            state.visible = true;
            //state.message = state.message ? state.message + "<br>"+ msg : msg;
            state.message += '<p>' + msg + '</p>';
            return state;
        });
        tm = setTimeout(function () {
            update(state => {
                state.visible = false;
                return state;
            });
            setTimeout(function () {
                update(state => {
                    state.message = "";
                    return state;
                });
            }, 300);

        }, 5000);
    }
}
export default error;